import React, { Component } from "react";
import { SectionContainer } from "../../common/SectionContainer";
import { CFSingleSelect } from "select";
import * as supervisorActions from "../redux/supervisor_time_off_actions";
import * as actions from "../redux/time_off_actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { TabContainer } from "./TabContainer";
import * as notificationActions from "../../common/redux/actions";

export class SupervisorTimeOff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            MUItems: [],
            TabType: "Pending",
            ManagementUnitValue: this.props.ManagementUnitID !== undefined ? this.props.ManagementUnitID : -1,
            RequestStatusEnumItems: {},
            isRefreshNeeded: false
        };

        this.dropDownChange = this.dropDownChange.bind(this);
        this.getEnumValue = this.getEnumValue.bind(this);

        if (this.props.actions.fetchAllMUAction) {
            this.props.actions.fetchAllMUAction();
        }

        var requestParameters = {
            Page: 1,
            PageSize: 9999,
            SortOrder: "desc",
            SortColumn: "DateCreated",
            customFilters: [
                {
                    PropertyName: "ManagementUnitID",
                    Operation: 1,
                    Value: this.state.ManagementUnitValue
                },
                { PropertyName: "RequestStatus", Operation: 1, Value: "0" }
            ]
        };

        if (this.props.actions.fetchCurrentRequestsAction) {
            this.props.actions.fetchCurrentRequestsAction(requestParameters);
        }

        this.dropDownChange = this.dropDownChange.bind(this);
        this.filterRequests = this.filterRequests.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        //refresh after supervisor click out
        if(this.props.clickSwitch !== nextProps.clickSwitch && nextProps.ManagementUnitID !== undefined) {
            this.setState({
                ManagementUnitValue: nextProps.ManagementUnitID,
                isRefreshNeeded: true
            })
        }
       
        if (this.props.MUItems !== nextProps.MUItems) {
            let items = [];

            Object.keys(nextProps.MUItems).forEach(function(keyName, keyIndex) {
                items.push({
                    value: keyName,
                    label: nextProps.MUItems[keyName]
                });
            });

            this.setState({ MUItems: items });
        }

        if (nextProps.TabType) {
            this.setState({
                TabType: nextProps.TabType
            });
        }

        if (this.props.TabType !== nextProps.TabType) {
            this.setState({ TabType: nextProps.TabType });

            let requestStatusValue = this.getEnumValue(
                this.state.RequestStatusEnumItems,
                nextProps.TabType
            );

            var requestParameters = {
                Page: 1,
                PageSize: 9999,
                SortOrder: "desc",
                SortColumn: "DateCreated",
                customFilters: [
                    {
                        PropertyName: "ManagementUnitID",
                        Operation: 1,
                        Value: this.state.ManagementUnitValue
                    },
                    {
                        PropertyName: "RequestStatus",
                        Operation: 1,
                        Value: requestStatusValue
                    }
                ]
            };

            this.props.actions.fetchCurrentRequestsAction(requestParameters);
        }

        if (this.props.RequestStatusEnumItems !== nextProps.RequestStatusEnumItems) {
            //project data
            var requestStatusMap = {};

            Object.keys(nextProps.RequestStatusEnumItems).forEach(function(
                keyName,
                keyIndex
            ) {
                let r = nextProps.RequestStatusEnumItems[keyName];
                var key = r.key;
                var value = r.value;
                requestStatusMap[value] = key;
            });

            this.setState({
                RequestStatusEnumItems: requestStatusMap
            });
        }

        //reset refresh flag
        if(this.props.CurrentRequests !== nextProps.CurrentRequests){
            this.setState({                
                isRefreshNeeded: false
            })
        }
    }

    getEnumValue(map, key) {
        let enumValue = "";
        if (map) {
            enumValue = map[key];
            return enumValue;
        }
    }

    dropDownChange(event) {
        if (this.state.ManagementUnitValue !== event.target.value) {
            this.setState({
                ManagementUnitValue: event.target.value
            });

            let requestStatusValue = this.getEnumValue(
                this.state.RequestStatusEnumItems,
                this.state.TabType
            );

            var requestParameters = {
                Page: 1,
                PageSize: 9999,
                SortOrder: "desc",
                SortColumn: "DateCreated",
                customFilters: [
                    {
                        PropertyName: "ManagementUnitID",
                        Operation: 1,
                        Value: event.target.value
                    },
                    {
                        PropertyName: "RequestStatus",
                        Operation: 1,
                        Value: requestStatusValue
                    }
                ]
            };

            if (this.props.actions.fetchCurrentRequestsAction) {
                this.props.actions.fetchCurrentRequestsAction(
                    requestParameters
                );
            }
        }
    }

    filterRequests(e, dataKeys) {
        let { CurrentRequests } = this.props; 
        if (!CurrentRequests) return;
        let filterValue = e.target.value.toLowerCase();
        if (filterValue === "all" || filterValue === "") {
            this.props.actions.filterRequestsAction(CurrentRequests);
        }
        let filteredRequests = CurrentRequests.filter(item => dataKeys.some((key) => String(item[key]).toLowerCase().includes(filterValue)));
        this.props.actions.filterRequestsAction(filteredRequests);
    }

    render() {
        let options = this.state.MUItems;
        return (
            <div>
                <SectionContainer
                    className="supervisor-section-container"
                    titleText="Time Off Requests"
                >
                    <CFSingleSelect
                        options={options}
                        className="mu-dropdown"
                        onChangeEvent={event => this.dropDownChange(event)}
                        value={this.state.ManagementUnitValue}
                    />
                    
                    <input
                        placeholder="Search ID or agent..."
                        onChange={e => this.filterRequests(e, ["agentName", "agentId"])}
                    />
                    <TabContainer
                        TabType={this.state.TabType}
                        ManagementUnitID={this.state.ManagementUnitValue}
                        isRefreshNeeded = {this.state.isRefreshNeeded}
                    />
                </SectionContainer>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        MUItems: state.timeoff.MUItems,
        CurrentRequests: state.timeoff.CurrentRequests,
        RequestStatusEnumItems: state.timeoff.RequestStatusEnumItems,
        clickSwitch: state.common.clickSwitch
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            { ...actions, ...supervisorActions, ...notificationActions },
            dispatch
        )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SupervisorTimeOff);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/SupervisorTimeOff.js